import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { z } from 'zod';

export const GetAccountInfoResponseDataSchema = z.object({
  businessCategory: z.enum(['NATURAL_PERSON', 'SOLO_PROPRIETORSHIP', 'LEGAL_ENTITY']),
  bankName: z.string(),
  bankAccountNumber: z.string(),
  bankOwnerName: z.string(),
  residentRegistrationNumber: z.string().nullable(),
  registeredBusinessName: z.string().nullable(),
  companyRegistrationNumber: z.string().nullable(),
});

export type GetAccountInfoResponseData = z.infer<typeof GetAccountInfoResponseDataSchema>;

export type GetAccountInfoResponse = MusinsaStandardResponse<GetAccountInfoResponseData>;
